import React, { Fragment } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Fade from "react-reveal/Fade"
import Text from "../../atoms/Text"
import {
    ContainerWrapper,
    LayeredDivWrapper,
    ImageWrapper,
    ContentWrapper,
    ImageTextOverlayWrapper
} from "./aboutUsLanding.style"

const AboutUsLandingSection = ({
    textOverlayFontOverride
}) => {
    const Data = useStaticQuery(graphql`
        query {
            dataJson {
                ABOUT_US_PAGE {
                    mission {
                        header
                        content
                    }
                    content {
                        header
                        paragraphs
                    }
                }
            }
        }
    `);

    const aboutUsPageData = Data.dataJson.ABOUT_US_PAGE[0];

return (
    <ContainerWrapper>
        <LayeredDivWrapper>
            <ImageWrapper>
                <StaticImage src="../../../images/about-page-overpass.jpg" layout="fullWidth" alt="about page landing image"></StaticImage>
            </ImageWrapper>
            <Fade right>
                <ImageTextOverlayWrapper>
                    <Text className="header" content={aboutUsPageData.mission.header} {...textOverlayFontOverride}></Text>
                    <Text className="content" content={aboutUsPageData.mission.content} {...textOverlayFontOverride}></Text>
                </ImageTextOverlayWrapper>
            </Fade>
            <Fade left>
                <ContentWrapper>
                    <Text className="header" content={aboutUsPageData.content.header}></Text>
                    {aboutUsPageData.content.paragraphs.map((paragraph, index) => {
                        return (<Fragment key={`about-us-content-fragment-${index}`}><Text className="content" content={paragraph}></Text></Fragment>)
                    })}
                </ContentWrapper>
            </Fade>
        </LayeredDivWrapper>
    </ContainerWrapper>
)};

AboutUsLandingSection.defaultProps = {
    textOverlayFontOverride: {
        color: 'white'
    }
};


export default AboutUsLandingSection;
